// extracted by mini-css-extract-plugin
module.exports = {"dialogHeader":"WarningOkDialog_dialogHeader__3I4Ry"};